/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FileTypePresentationIcon16Light } from './FileTypePresentationIcon16Light';
import { FileTypePresentationIcon16Regular } from './FileTypePresentationIcon16Regular';
import { FileTypePresentationIcon16Solid } from './FileTypePresentationIcon16Solid';
import { FileTypePresentationIcon20Light } from './FileTypePresentationIcon20Light';
import { FileTypePresentationIcon20Regular } from './FileTypePresentationIcon20Regular';
import { FileTypePresentationIcon20Solid } from './FileTypePresentationIcon20Solid';
import { FileTypePresentationIcon24Regular } from './FileTypePresentationIcon24Regular';
import { FileTypePresentationIcon24Solid } from './FileTypePresentationIcon24Solid';
import { FileTypePresentationIcon32Regular } from './FileTypePresentationIcon32Regular';
import { FileTypePresentationIcon64Regular } from './FileTypePresentationIcon64Regular';
var sizes = {
    16: {
        light: FileTypePresentationIcon16Light,
        regular: FileTypePresentationIcon16Regular,
        solid: FileTypePresentationIcon16Solid,
    },
    20: {
        light: FileTypePresentationIcon20Light,
        regular: FileTypePresentationIcon20Regular,
        solid: FileTypePresentationIcon20Solid,
    },
    24: {
        regular: FileTypePresentationIcon24Regular,
        solid: FileTypePresentationIcon24Solid,
    },
    32: {
        regular: FileTypePresentationIcon32Regular,
    },
    64: {
        regular: FileTypePresentationIcon64Regular,
    },
};
export var FileTypePresentationIcon = forwardRef('FileTypePresentationIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
